// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';
import { classicFormat, percentFormat } from '@/utils/hooks/format/useFormatNumber';

// Components
import AgeGenderChart from '@/components/composite/Charts/composed/AgeGenderChart';

export const ageGenderConfig = {
    margin: {
        right: 20,
        left: -20
    },
    name: {
        age: 'age',
        female: 'female',
        male: 'male',
        percentage_male: 'percentage_male',
        percentage_female: 'percentage_female'
    },
    datePickerDoesNotApply: true,
    deprecated: { status: '03/14/2024' },
    id: 'ages_genders_distribution',
    social: FACEBOOK,
    color: {
        female: 'purple',
        male: 'red'
    },
    valueFormat: {
        ...classicFormat,
        signDisplay: 'never'
    },
    orientation: 'vertical',
    pieValueFormat: percentFormat,
    tooltipValueTranslation: 'chart.facebook.age_gender_tooltip_translation',
    pieTooltipTranslation: {
        token: 'chart.facebook.age_gender_tooltip_pie_translation',
        values: ['gender', 'value', 'percentage']
    },
    tooltip: 'chart.facebook.tooltip_age_gender',
    size: SIZE_50,
    type: 'chart',
    element: AgeGenderChart,
    defaultFilter: 'global',
    filters: {
        global: {
            title: 'chart.facebook.age_gender_fans',
            menu: 'chart.facebook.age_gender_filter_fans'
        },
        reach: {
            title: 'chart.facebook.age_gender_reached',
            menu: 'chart.facebook.age_gender_filter_reached'
        },
        engagement: {
            title: 'chart.facebook.age_gender_engaged',
            menu: 'chart.facebook.age_gender_filter_engaged'
        }
    }
};
